export default "__VITE_ASSET__CcBkUEJD__"